import {Outlet} from "react-router-dom";
export const RootPage = () => {
  return <Outlet />;
};
